var map = {
	"./BNXT-awards-image-min.png": 6499,
	"./BNXT_bubble.png": 5999,
	"./award-categories/BNXT_Awards-winner-achievement-min.png": 9384,
	"./award-categories/BNXT_Awards-winner-coach-min.png": 5231,
	"./award-categories/BNXT_Awards-winner-defensive-min.png": 5443,
	"./award-categories/BNXT_Awards-winner-dreamteam-min.png": 4338,
	"./award-categories/BNXT_Awards-winner-mvp-min.png": 5486,
	"./award-categories/BNXT_Awards-winner-player-min.png": 6119,
	"./award-categories/BNXT_Awards-winner-referee-min.png": 5427,
	"./award-categories/BNXT_Awards-winner-rising-min.png": 7482,
	"./award-categories/BNXT_Awards-winner-sixthman-min.png": 7951,
	"./awards_bg-min.png": 4305,
	"./bnx_bg-mvp-bubble-min.png": 3182,
	"./bnx_comet-big-blue-min-979x1024.png": 5022,
	"./bnx_comet-big-orange-min-979x1024.png": 4702,
	"./bnx_comet-big-purple-min-979x1024.png": 3147,
	"./bnx_comet-big-red-min-979x1024.png": 8523,
	"./bnx_comet-big-yellow-min-979x1024.png": 4292,
	"./bnx_comet-small-blue-min-979x1024.png": 9493,
	"./bnx_comet-small-lightblue-min-979x1024.png": 1734,
	"./bnx_comet-small-orange-min-979x1024.png": 7487,
	"./bnx_comet-small-purple-min-979x1024.png": 2999,
	"./bnx_comet-small-yellow-min-979x1024.png": 2068,
	"./bnxt_ball-min-1024x1024.png": 6494
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9725;